var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blue lighten-4 pt-14"},[_c('page-title',{attrs:{"id":"reading-title"}},[_vm._v("Reading")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }